import React, {useEffect, useState} from 'react';

import {useLoaderData, useNavigation} from "react-router-dom";

import {isMobile} from "react-device-detect";

import {hasFullAccess} from 'ultra/helpers/auth';

import {useGlobalCustomContext} from '../../../../Helpers/context';

import {getUsers} from '../../Helpers/admin';

import {getModule} from '../../../../Helpers/module'
// import {attachUsersForFields} from '../../Helpers/user';

import PreloaderTable from '../../../../Components/Preloaders/PreloaderTable'

import {getActions, UserTableInlineActions} from '../../Components/UserInlineActions'
import UserAdminActions from '../../Components/UserAdminActions'

import {TableView} from '../../../Content/Widgets/Table'
import BreadcrumbsWidget from '../../../Content/Widgets/Breadcrumbs'
import TitleWidget from '../../../Content/Widgets/Title'
import FiltersLine from '../../../Content/Widgets/FiltersLine';

import {useContentStore} from '../../../../Stores/content';
// import {useBackdropPreloaderStore} from '../../../../Stores/backdropPreloader';

import {NODE_ACTIONS} from '../../../Content/Reducers/node';

import {setPageTitle} from '../../../../Helpers/router';

import './index.scss';

const TITLE = 'Користувачі';

function attachExtraUserFields(fields) {
    fields = {
        ...fields,
        email: {
            type: 'text',
            placeholder: 'Email'
        },
        id: {
            type: 'text',
            placeholder: 'User ID'
        },
        emailNotVerified: {
            type: 'boolean',
            placeholder: 'Підтверджений email',
            options: {
                labels: {
                    true: 'ні',
                    false: 'так'
                }
            }
        },
        sendEmailVerification: {
            type: 'boolean',
            placeholder: 'Запит на верифікацію email',
            options: {
                labels: {
                    true: 'відправлено',
                }
            }
        },
        _not_checked: {
            type: 'boolean',
            placeholder: 'Перевірка',
            options: {
                labels: {
                    true: 'не проводилась',
                }
            }
        },
        _blocked: {
            type: 'boolean',
            placeholder: 'Заблоковано',
            options: {
                labels: {
                    true: 'так',
                }
            }
        },
        __blocked_comment: {
            type: 'text',
            placeholder: 'Причина блокування',
        },
        creationTime: {
            type: 'text',
            placeholder: 'Створено'
        },
        userStatus: {
            type: 'userStatus',
            placeholder: 'Останній вхід'
        }
    }

    fields.displayName.type = 'user-title';

    return fields;
}

export default () => {
    const rawUsers = useLoaderData();

    const navigation = useNavigation();

    const {content, setContent} = useContentStore();
    const {nodeState, userState, nodeDispatch} = useGlobalCustomContext();

    const [tableOptions, setTableOptions] = useState();
    const [fields, setFields] = useState();

    useEffect(() => {
        getModule('profile').then(profile => {
            setFields(attachExtraUserFields(profile.editForm.fields));
        })

        setTableOptions(isMobile ? {
            visible: ['photoURL', 'displayName'],
            hidden: ['_blocked', '__blocked_comment', 'email', 'emailNotVerified', 'messenger', 'facebook', 'instagram', 'sendEmailVerification', '_not_checked', 'creationTime', 'lastSignInTime', 'id'],
            noHeaders: true
        } : {
            visible: ['photoURL', 'displayName', 'messenger', 'creationTime'],
            hidden: ['_blocked', '__blocked_comment', 'email', 'emailNotVerified', 'facebook', 'instagram', 'sendEmailVerification', '_not_checked', 'lastSignInTime', 'id']
        })

        setPageTitle(TITLE);
    }, [])

    useEffect(() => {
        if (nodeState.updatePageContentStart) {
            nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_END});
            updatePage()
        }
    }, [nodeState.updatePageContentStart])

    useEffect(() => {
        if (navigation.state === 'idle') {
            setContent(rawUsers)
        }
    }, [navigation])

    const updatePage = () => {
        const url = new URL(window.location.href);

        // setContent({});
        getUsers(url.search)
            .promise
            .then(setContent)
    }

    const selectClasses = (data) => {
        if (data?._not_checked) {
            return 'not_checked'
        }
        if (data?._blocked) {
            return 'blocked'
        }
    }

    const title = {
        title: TITLE
    }

    const permits = {
        children: {
            read: ['node']
        }
    }

    const config = {
        showFilters: {
            filterByInline: [
                {
                    id: 'users',
                    field: {
                        default: 'not_checked',
                        type: "complex",
                        placeholder: "Фільтр",
                        options: {
                            hasNoEmptyValue: true,
                        },
                        values: {
                            values: {
                                not_checked: "Неперевірені користувачі",
                                checked: "Перевірені користувачі",
                                blocked: "Заблоковані",
                            },
                            order: [
                                'not_checked',
                                'blocked',
                                'checked',
                            ]
                        }
                    }
                },
            ]
        }
    }

    const breadcrumbs = {}

    return <div  className='Content'>
                <div className='ProfileUsersPage'>
                    <TitleWidget permits={permits} content={title} config={config} breadcrumbs={breadcrumbs} />
                    <BreadcrumbsWidget hideRoot links={breadcrumbs} />

                    {isMobile && <div className='MobileFiltersLine'>
                        <FiltersLine
                            size="small"
                            filters={config?.showFilters?.filterByInline}
                        />
                    </div>}

                    {!fields && <PreloaderTable/>}

                    {fields && content.children && <TableView
                        content={content.children}
                        fields={fields}
                        showPagination={true}
                        tableOptions={tableOptions}
                        selectClasses={selectClasses}

                        actionsComponent={UserTableInlineActions}
                        actionsProps={{
                            unfolded: isMobile
                        }}
                        hasActions={(data, id) => getActions({
                            user: data.list[id],
                            hasFullAccess: hasFullAccess(userState.user)
                        })}
                    />}
                </div>

                <UserAdminActions />
            </div>
}
